import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { RestaurantMenu } from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';
import Loader from "../Loader/Loader";
import { makeStyles } from '@material-ui/core/styles';
import StarIcon from "@material-ui/icons/Star";
import logo from './image.jpeg'
import ContactDetail from "../Flight/ContactDetail";
import GuestList from "./GuestList";
import PaymentCard from "../Flight/PaymentCard";
import { connect } from "react-redux";
import { toggleSignUp, getUserDetails } from "../../store/actions/user/User";
import { getVendorDetails } from "../../store/actions/vendor/Vendor";
import MySnackbar from '../MySnackBar';
import { saveHotelBooking } from "../../store/actions/flights/Flights";



const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 1,
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
    }
};

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        height: 140,
        width: 100,
        backgroundColor: 'var(--white)'
    },
    control: {
        padding: "2%",
        marginBottom: "2%",
        backgroundColor: 'var(--white)'
    },
    mapView: {
        [theme.breakpoints.up("sm")]: {
            position: 'fixed',
            width: '100%',
            right: '0px'
        }
    },
    tableView: {
        borderCollapse: 'collapse',
        borderSpacing: '0',
        width: '100%',
        border: '1px solid #ddd'
    },

    tableHead: {
        textAlign: 'left',
        padding: '8px'
    }
}));



function HotelRoomsBook(props) {
    const [activeIndex, setActiveIndex] = useState(0)
    const [showSnackBar, setShowSnackBar] = useState({ show: true, message: "", type: "" });
    const classes = useStyles();
    const search = useLocation().search;
    const searchParam = new URLSearchParams(search);
    const check_in_date = searchParam.get("check_in_date");
    const id = searchParam.get("id");
    const check_out_date = searchParam.get("check_out_date");
    const location = searchParam.get("location");
    const adult_count = searchParam.get("adult_count")
    const source_market = searchParam.get("source_market");
    const room_count = searchParam.get("room_count");
    const currency = searchParam.get("currency");
    const rate_plan_id = searchParam.get("rate_plan_id");
    const [roomsArr, setRoomsArr] = useState([])
    const [submitLoader, setSubmitLoader] = useState(false)

    const [hotel, setHotel] = useState([])
    const [loading, setLoading] = useState(false)

    const searchHotels = async () => {
        if (!check_in_date || !check_out_date || !location || !adult_count)
            return;
        setLoading(true);
        var queryParam = `hotels/pre-book-dida`;
        let occupancyDetails = []
        for (var i = 1; i <= Number(room_count); i++) {
            occupancyDetails.push({
                "ChildCount": 0,
                "AdultCount": 0,
                "RoomNum": i,
                "GuestInfo": []
            })
        }
        let j = 0
        while (j < Number(adult_count)) {
            for (var i = 0; i < Number(room_count); i++) {
                occupancyDetails[i]['AdultCount'] = occupancyDetails[i]['AdultCount'] + 1
                j++;
                if (j >= Number(adult_count)) {
                    break;
                }
            }
        }
        for (var i = 0; i < Number(room_count); i++) {
            for (let j = 0; j < occupancyDetails[i]['AdultCount']; j++) {
                let gi = occupancyDetails[i]['GuestInfo']
                gi.push({ "IsAdult": true, "Name": { "Last": "", "First": "" } })
                occupancyDetails[i]['GuestInfo'] = gi
            }
        }
        setRoomsArr(occupancyDetails)
        let response2 = await axios.post(queryParam, {
            "checkOutDate": check_out_date,
            "checkInDate": check_in_date,
            "roomCount": Number(room_count),
            "hotelId": id,
            "occupancyDetails": occupancyDetails,
            "currency": currency,
            "nationality": source_market,
            "ratePlanId": rate_plan_id
        });
        setLoading(false);
        if (response2 && response2.data && response2.data.data) {
            var data = response2.data.data;
            // if (data.status !== 'complete') {
            //     setTimeout(searchHotels, 3000)
            // } else {

            if (data && data.Success) {
                let d = data.Success.PriceDetails.HotelList
                // }
                // if (data && data.hotels && data.hotels.length > 0) {
                setHotel(d[0]);
            }
            // }
        }

    };

    useEffect(() => {
        searchHotels()
    }, [])

    const getImageUrl = (data) => {
        if (data.links.l) {
            return data.links?.l?.href
        } else if (data.links.m) {
            return data.links.m.href
        } else if (data.links.s) {
            return data.links.s.href
        }
        return ''
    }

    const getImage = (meta_data) => {
        if (meta_data.hero_images && meta_data.hero_images.length > 0) {
            if (meta_data?.hero_images[0].links.m) {
                return meta_data?.hero_images[0].links?.m?.href
            } else if (meta_data?.hero_images[0].links.s) {
                return meta_data?.hero_images[0].links.s.href
            } else if (meta_data?.hero_images[0].links.l) {
                return meta_data?.hero_images[0].links.l.href
            }
        } else if (meta_data.images && meta_data.images.length > 0) {
            let url = ''
            meta_data.images.map((im) => {
                if (im.hero_image) {
                    if (im.links.m) {
                        url = im.links?.m?.href
                    } else if (im.links.s) {
                        url = im.links.s.href
                    } else if (im.links.l) {
                        url = im.links.l.href
                    }
                }
            })
            if (url == '') {
                if (meta_data.images[0].links.m) {
                    url = meta_data.images[0].links?.m?.href
                } else if (meta_data.images[0].links.s) {
                    url = meta_data.images[0].links.s.href
                } else if (meta_data.images[0].links.l) {
                    url = meta_data.images[0].links.l.href
                }
            }
            return url
        }
        return ''
    }

    const proceedToPayment = async (token) => {
        const { saveBooking, email, phone, firstName, lastName } = props;


        let guestList = []
        let listValid = true

        setSubmitLoader(true);
        saveBooking(
            {
                "checkOutDate": check_out_date,
                "checkInDate": check_in_date,
                "roomCount": parseInt(room_count),
                "hotelId": id,
                "guestList": roomsArr,
                useWallet: token.id === "NOT_REQUIRED",
                payment_token: token.id,
                "occupancyDetails": roomsArr,
                "currency": currency,
                "nationality": source_market,
                "ratePlanId": rate_plan_id,
                contact: {
                    Name: {
                        First: firstName,
                        Last: lastName
                    },
                    Email: email,
                    Phone: phone
                }
            }
        )
            .then((res) => {
                setSubmitLoader(false)
                setShowSnackBar({ show: true, message: 'Hotel booked successfully!', type: 'success' });
                props.history.push("/hotels");
            })
            .catch((err) => {
                setShowSnackBar({ show: true, message: 'Something went wrong!', type: 'error' });
                setSubmitLoader(false)
            });
    };

    return (<div className={classes.root} style={{ backgroundColor: "var(--backgroundcolor)", color: "var(--white)", padding: '42px', paddingTop: '100px' }}>
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} style={{ marginTop: '40px' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={12} sm={8}>
                                <Grid container>
                                    <Grid item xs={10}>
                                        <Typography
                                            variant="h5"
                                            style={{ color: "var(--darker)", textTransform: "capitalize", textAlign: 'left', fontWeight: '500' }}
                                        >
                                            {hotel?.meta_data?.Name}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography component="p" className="text-left">
                                            <StarIcon style={{ color: "var(--green)", fontSize: "20px", marginTop: '-5px' }} /> {hotel?.meta_data?.StarRating}{" "}
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{hotel?.meta_data?.Address}{" "}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={12} sm={8}>
                                <Carousel partialVisible={true}
                                    responsive={responsive}
                                >{hotel?.meta_data && hotel.meta_data.Images ? hotel.meta_data.Images.map((im) => {
                                    return <img style={{ borderRadius: '12px', objectFit: 'cover' }} width="100%" height="450" src={im.ImageUrl} />
                                }) : <img style={{ borderRadius: '12px', objectFit: 'cover' }} width="100%" height="450" src={logo} />}
                                </Carousel>
                            </Grid>
                            <Grid item xs={2}></Grid>

                            <Grid item xs={2}></Grid>
                            <Grid item xs={12} sm={8} style={{ textAlign: 'left' }}>
                                <Typography
                                    variant="h6"
                                    style={{ color: "var(--darker)", textTransform: "capitalize" }}
                                >{'Room Selected'}</Typography>
                                <Grid item xs="12" style={{ marginTop: '10px' }}>
                                    <Paper className={classes.control} elevation={0}>
                                        <Grid container spacing={4}>
                                            <Grid item xs="12" sm="6">
                                                <Typography component="p" style={{ textAlign: 'left' }}>Room Name : {hotel?.RatePlanList?.[0]?.RatePlanName}</Typography>
                                            </Grid>
                                            <Grid item xs="12" sm="6">
                                                <Typography component="p" style={{ textAlign: 'left' }}>Price : {hotel?.RatePlanList?.[0]?.Currency} {hotel?.RatePlanList?.[0]?.TotalPrice}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Typography
                                    variant="h6"
                                    style={{ color: "var(--darker)", textTransform: "capitalize" }}
                                >{'Cancellation Policy'}</Typography>
                                <Grid item xs="12" style={{ marginTop: '10px' }}>
                                    <Paper className={classes.control} elevation={0}>
                                        <Grid container spacing={4}>
                                            {hotel?.CancellationPolicyList && hotel?.CancellationPolicyList.map((policy) => {
                                                return <>
                                                    <Grid item xs="12" sm="6">
                                                        <Typography component="p" style={{ textAlign: 'left' }}>Cancellation Charges : {hotel?.RatePlanList?.[0]?.Currency} {policy.Amount}</Typography>
                                                    </Grid>
                                                    <Grid item xs="12" sm="6">
                                                        <Typography component="p" style={{ textAlign: 'left' }}>From Date : {new Date(policy.FromDate).toLocaleDateString()}</Typography>
                                                    </Grid>
                                                </>
                                            })}
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <ContactDetail showName={true} />
                                <Grid item xs="12" style={{ marginTop: '10px' }}>
                                    <GuestList roomsArr={roomsArr} handleChange={(v)=>{
                                        setRoomsArr([...v])
                                    }}/>
                                </Grid>
                                {/* {JSON.stringify({price:price ,
               vendorComm: getCommision(price,props.commissionType,props.commissionValue),
               adminComm: getCommision(price,props.adminCommissionType,props.adminCommissionValue),
                bagPrice:baggagePrice,bagvendorComm: getCommision(baggagePrice,props.commissionType,props.commissionValue),
               adminVendorComm: getCommision(baggagePrice,props.adminCommissionType,props.adminCommissionValue)})} */}
                                <PaymentCard
                                    onSuccess={proceedToPayment}
                                    price={hotel?.TotalPrice}
                                    canBook={true}
                                />

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </Grid>
        <Loader show={loading || submitLoader} />
        <MySnackbar show={showSnackBar.show} onClose={() => setShowSnackBar({ show: false, message: "", type: "info" })} message={showSnackBar.message} type={showSnackBar.type} />
    </div >)

}

const mapStateWithProps = (state) => {
    let commissionType = ""
    let commissionValue = 0
    let vendorCurrency;
    if (state.vendor && state.vendor.vendorDetail) {
        commissionType = state.vendor.vendorDetail.commissionType;
        commissionValue = state.vendor.vendorDetail.commissionValue;
        vendorCurrency = state.vendor.vendorDetail.currency;
    }
    let adminCommissionType = "Fixed"
    let adminCommissionValue = 0
    if (state.admin && state.admin.commission && state.admin.commission.commissionType) {
        adminCommissionType = state.admin.commission.commissionType;
        adminCommissionValue = state.admin.commission.commissionValue;
    }
    return {
        auth: state.user.auth,
        userDetails: state.user.userDetails,
        passengers: state.flight.passengers,
        email: state.flight.email,
        firstName: state.flight.firstName,
        lastName: state.flight.lastName,
        phone: state.flight.phone,
        currency: state.flight.currency ? state.flight.currency : "",
        listValid: state.flight.passengerListValid,
        commissionType: commissionType,
        commissionValue: commissionValue,
        vendorCurrency,
        adminCommissionType,
        adminCommissionValue
    }
}

const mapDispatchToProps = (dispatch) => ({
    getUserDetails: () => dispatch(getUserDetails()),
    getVendorDetails: () => dispatch(getVendorDetails()),
    saveBooking: (data) => dispatch(saveHotelBooking(data)),
});

export default connect(mapStateWithProps, mapDispatchToProps)(HotelRoomsBook);
